<template>
  <div class="why">
    <img src="@/assets/img/shapes/shape-1.svg" alt="" class="shape-1">
    <img src="@/assets/img/shapes/shape-2.svg" alt="" class="shape-2">
    <container>
      <div class="why__wrp">
        <div class="why__cnt">
          <div class="title color-white">
            <span class="color-light-green">Why and How</span> <br>
            GovTech Cinema<span class="color-light-green">.com?</span>
          </div>
          <p class="text color-white myweight" v-if="settings">
            {{ settings.setting.home_spot }}
          </p>

          <v-link
            class="button--more color-light-green"
            title="Read More"
            icon="icon-arrow-long-right"
            icon-position="right"
            to="/about"
          />
        </div>

        <div class="city-images">
          <img src="@/assets/img/popular-cities.png" alt="" class="city-images__item">
          <div v-on:click="go()" class="city-images__cnt">
            <img src="@/assets/img/shapes/shape-3.svg" alt="" class="city-images__shape">
            <img src="@/assets/img/pin.svg" alt="" class="city-images__icon">
              <div class="city-images__content" v-if="settings">
              <div v-on:click="go()" class="city-images__title">
                <span v-on:click="go()" class="color-pink d-block font-700 font-size-22">{{ settings.cities }} Genre</span>
                {{ settings.dorms }} Active Movie
              </div>
            </div>
          </div>
        </div>

      </div>
    </container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Why',
  computed: {
    ...mapGetters(['settings'])
  },
  methods: {
     go () {
        this.$router.push('/genres')
    }  
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/why";
  .myweight {
    font-weight: 400;
  }
</style>
